<template>

  <section class="dp-layout">
    <!-- 
    <section class="dp-left" :style="{
      display: this.$store.state.HasChildrenDepartment ? 'block' : 'none',
    }"> -->
    <section class="dp-left">
      <DepartmentPane directory-scope="school" @tree-node-click="treeNodeClick" :type="1"></DepartmentPane>
    </section>

    <section class="dp-right">
      <!--工具条-->
      <toolbar :buttonList="buttonList" @callFunction="callFunction" :searchList="searchList"></toolbar>

      <!--列表-->
      <div class="tbl-scroll-host">
      <el-table :data="users" v-loading="listLoading" @select="dialogCheck" @row-click="selectCurrentRow" ref="table"
        class="custom-tbl" height="100%" style="width: 100%">
        <el-table-column type="selection" width="50"> </el-table-column>

        <el-table-column prop="Name" label="名称" width align="center">
        </el-table-column>

        <el-table-column prop="DepartmentName" label="部门" width align="center">
        </el-table-column>

        <el-table-column prop="GradeName" label="年级" min-width="150" align="center">
          <template slot-scope="scope">
            <el-button
              v-if="parseGradeNames(scope.row.GradeName).length"
              type="text"
              size="small"
              icon="el-icon-reading"
              class="schedule-grade-link-btn"
              @click.stop="openGradeViewDialog(scope.row)">
              已选 {{ parseGradeNames(scope.row.GradeName).length }} 个年级
            </el-button>
            <el-tag
              v-else
              size="small"
              type="info"
              effect="plain"
              class="schedule-scope-tag">
              全校通用（未限制年级）
            </el-tag>
          </template>
        </el-table-column>

        <el-table-column prop="Priority" label="优先级" width align="center">
        </el-table-column>

        <el-table-column prop="IsDefault" label="默认" width="90" align="center">
          <template slot-scope="scope">
            <el-tag v-if="Number(scope.row.IsDefault) === 1" size="small" type="success" effect="light">是</el-tag>
            <el-tag v-else size="small" type="info" effect="plain">否</el-tag>
          </template>
        </el-table-column>

        <el-table-column prop="Remarks" label="备注" width align="center">
        </el-table-column>
        <el-table-column prop="CreateTime" label="添加时间" width="160" align="center">
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="200" align="center">
          <template slot-scope="scope">
            <el-button type="text" @click="openPeriods(scope.row)">节次管理</el-button>
          </template>
        </el-table-column>

      </el-table>
      </div>

      <!--工具条-->
      <el-col :span="24" class="toolbar">
        <el-pagination layout="total, prev, pager, next, jumper" @current-change="handleCurrentChange" :page-size="10"
          :total="total" style="float: right">
        </el-pagination>
      </el-col>

      <!--编辑界面-->
      <el-dialog title="编辑作息方案" :visible.sync="editFormVisible" v-model="editFormVisible" :close-on-click-modal="false"
        destroy-on-close>
        <el-form :model="editForm" label-width="80px" :rules="editFormRules" ref="editForm">

          <el-form-item label="名称" prop="Name">
            <el-input v-model="editForm.Name" auto-complete="off"></el-input>
          </el-form-item>

          <!-- 去除所属机构选择，直接关联页面统一选中的学校 ID -->

          <!-- 新增年级选择（支持多选） -->
          <el-form-item label="年级" prop="GradeIds">
            <el-select v-model="editForm.GradeIds" multiple placeholder="请选择年级">
              <el-option v-for="item in gradeList" :key="item.Id" :label="item.Name" :value="item.Id"></el-option>
            </el-select>
          </el-form-item>

          <!-- 优先级 -->
          <el-form-item label="优先级" prop="Priority">
            <el-input-number v-model="editForm.Priority" :min="0" style="width: 120px;"></el-input-number>
            <span style="margin-left: 8px; color: #909399; font-size: 12px;">
              同一学校/年级范围内必须有且仅有一个默认方案；设为默认后其它方案自动取消默认。
            </span>
          </el-form-item>

          <!-- 是否默认 -->
          <el-form-item label="默认方案" prop="IsDefault">
            <el-switch
              v-model="editForm.IsDefault"
              :active-value="1"
              :inactive-value="0"
              @change="onEditDefaultChange"></el-switch>
          </el-form-item>

          <!-- 备注 -->
          <el-form-item label="备注" prop="Remarks">
            <el-input type="textarea" v-model="editForm.Remarks" rows="3"></el-input>
          </el-form-item>

        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click.native="editFormVisible = false">取消</el-button>
          <el-button type="primary" @click.native="editSubmit" :loading="editLoading">提交</el-button>
        </div>
      </el-dialog>

      <!--新增界面-->
      <el-dialog title="新增作息方案" :visible.sync="addFormVisible" v-model="addFormVisible" :close-on-click-modal="false"
        destroy-on-close>
        <el-form :model="addForm" label-width="80px" :rules="addFormRules" ref="addForm" class="demo-form-inline">

          <el-form-item label="名称" prop="Name">
            <el-input v-model="addForm.Name" auto-complete="off"></el-input>
          </el-form-item>

          <!-- 去除所属机构选择，直接关联页面统一选中的学校 ID -->

          <!-- 新增年级选择（支持多选） -->
          <el-form-item label="年级" prop="GradeIds">
            <el-select v-model="addForm.GradeIds" multiple placeholder="请选择年级">
              <el-option v-for="item in gradeList" :key="item.Id" :label="item.Name" :value="item.Id"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="优先级" prop="Priority">
            <el-input-number v-model="addForm.Priority" :min="0" style="width: 120px;"></el-input-number>
            <span style="margin-left: 8px; color: #909399; font-size: 12px;">
              同一学校/年级范围内必须有且仅有一个默认方案；范围内尚无默认时新建会自动设为默认。
            </span>
          </el-form-item>

          <el-form-item label="默认方案" prop="IsDefault">
            <el-switch v-model="addForm.IsDefault" :active-value="1" :inactive-value="0"></el-switch>
          </el-form-item>

          <el-form-item label="备注" prop="Remarks">
            <el-input type="textarea" v-model="addForm.Remarks" rows="3"></el-input>
          </el-form-item>

        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click.native="addFormVisible = false">取消</el-button>
          <el-button type="primary" @click.native="addSubmit" :loading="addLoading">提交</el-button>
        </div>
      </el-dialog>

      <!-- 列表适用年级查看弹窗。最后更新：2026-09-08 -->
      <el-dialog :title="viewGradeDialog.title" :visible.sync="viewGradeDialog.visible" width="600px"
        :close-on-click-modal="false" append-to-body custom-class="schedule-grade-view-dialog">
        <div class="schedule-view-head">
          <div class="schedule-view-head-item">
            <span class="label">方案：</span>
            <span class="val">{{ viewGradeDialog.name || '-' }}</span>
          </div>
          <div class="schedule-view-head-item">
            <span class="label">机构：</span>
            <span class="val">{{ viewGradeDialog.departmentName || '-' }}</span>
          </div>
          <div class="schedule-view-head-item">
            <span class="label">默认：</span>
            <span class="val">{{ viewGradeDialog.isDefault === 1 ? '是' : '否' }}</span>
          </div>
          <div class="schedule-view-head-item">
            <span class="label">总数：</span>
            <span class="val count-badge">{{ viewGradeDialog.grades ? viewGradeDialog.grades.length : 0 }} 个年级</span>
          </div>
        </div>

        <div class="schedule-view-toolbar">
          <el-input v-model="viewGradeDialog.filterKey" size="small" placeholder="搜索年级名称..." prefix-icon="el-icon-search"
            clearable class="schedule-view-search-input" />
          <el-button size="small" type="primary" plain icon="el-icon-document-copy" @click="copyAllGradeNames">
            复制全部年级
          </el-button>
        </div>

        <div class="schedule-view-table-wrap">
          <el-table :data="filteredViewGrades" size="small" max-height="340" border stripe class="schedule-view-table">
            <el-table-column type="index" label="序号" width="70" align="center" />
            <el-table-column prop="name" label="年级名称" min-width="260">
              <template slot-scope="scope">
                <span class="grade-text">{{ scope.row.name }}</span>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="100" align="center">
              <template slot-scope="scope">
                <el-button type="text" size="mini" icon="el-icon-document-copy" @click="copySingleGradeName(scope.row.name)">复制</el-button>
              </template>
            </el-table-column>
            <div slot="empty" class="schedule-view-empty">暂无匹配的年级</div>
          </el-table>
        </div>

        <div slot="footer" class="dialog-footer">
          <el-button @click="viewGradeDialog.visible = false">关闭</el-button>
        </div>
      </el-dialog>

      <!-- 节次管理弹窗 -->
      <el-dialog :title="`节次管理 - ${currentScheduleName}`" :visible.sync="periodDialogVisible" width="50%"
        :close-on-click-modal="false">
        <div style="margin-bottom: 8px; display:flex; justify-content:flex-end; align-items:center;">
          <div>
            <el-button size="mini" type="primary" @click="addPeriodDialog">新增节次</el-button>
          </div>
        </div>

        <el-table :data="periodList" v-loading="periodLoading" style="width: 100%;">

          <el-table-column prop="ClassNo" label="序号" width="60" align="center"></el-table-column>
          <el-table-column prop="PeriodName" label="节次名称" width="100" align="center"></el-table-column>
          <el-table-column label="日期" width="300" align="center">
            <template slot-scope="scope">
              <div class="combo-values">
                <div v-for="(line, idx) in groupedEffectiveLines(scope.row, false)" :key="`norm-d-${idx}`">
                  <div class="tag-line">
                    <el-tag v-for="(d, di) in parseEffectiveLine(line).days" :key="`n-${idx}-${di}`" type="info"
                      size="mini" style="margin-right:4px;">{{ d }}</el-tag>
                  </div>
                </div>
                <div v-if="groupedEffectiveLines(scope.row, false).length === 0"></div>

                <div v-for="(line, idx) in groupedEffectiveLines(scope.row, true)" :key="`alt-d-${idx}`"
                  style="margin-top:6px;">
                  <div class="tag-line">
                    <el-tag v-for="(d, di) in parseEffectiveLine(line).days" :key="`a-${idx}-${di}`" type="warning"
                      size="mini" style="margin-right:4px;">{{ d }}</el-tag>
                  </div>
                </div>
                <div v-if="groupedEffectiveLines(scope.row, true).length === 0"></div>
              </div>
            </template>
          </el-table-column>

          <el-table-column label="时间" width="160" align="center">
            <template slot-scope="scope">
              <div class="combo-values">
                <div v-for="(line, idx) in groupedEffectiveLines(scope.row, false)" :key="`norm-t-${idx}`">
                  <div class="time-line">{{ parseEffectiveLine(line).time }}</div>
                </div>
                <div v-if="groupedEffectiveLines(scope.row, false).length === 0"></div>

                <div v-for="(line, idx) in groupedEffectiveLines(scope.row, true)" :key="`alt-t-${idx}`"
                  style="margin-top:6px;">
                  <div class="time-line" style="color:#e6a23c">{{ parseEffectiveLine(line).time }}</div>
                </div>
                <div v-if="groupedEffectiveLines(scope.row, true).length === 0"></div>
              </div>
            </template>
          </el-table-column>

          <!-- <el-table-column prop="IsClass" label="是否上课" width="100">
            <template slot-scope="scope">
              <span>{{ scope.row.IsClass === 1 ? '是' : '否' }}</span>
            </template>
          </el-table-column> -->

          <!-- <el-table-column prop="TimeSlot" label="时间段分类" width="120"></el-table-column> -->

          <!-- <el-table-column prop="Remarks" label="备注"></el-table-column> -->
          <el-table-column fixed="right" label="操作" width="160" align="center">
            <template slot-scope="scope">
              <el-button size="mini" @click="editPeriodDialog(scope.row)">编辑</el-button>
              <el-button size="mini" type="danger" @click="removePeriod(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>

        <div slot="footer" class="dialog-footer">
          <el-button @click.native="periodDialogVisible = false">关闭</el-button>
        </div>
      </el-dialog>

      <!-- 节次编辑弹窗（新增/编辑共用） -->
      <el-dialog :title="periodForm && periodForm.Id > 0 ? '编辑节次' : '新增节次'" :visible.sync="periodEditDialogVisible"
        width="40%" :close-on-click-modal="false">
        <el-form :model="periodForm" label-width="90px" :rules="periodFormRules" ref="periodFormRef">
          <el-form-item label="序号" prop="ClassNo">
            <el-input-number v-model="periodForm.ClassNo" :min="0"></el-input-number>
          </el-form-item>
          <el-form-item label="节次名称" prop="PeriodName">
            <el-input v-model="periodForm.PeriodName"></el-input>
          </el-form-item>

          <!-- 适用日期（主）按钮组，默认周一-周日都选中 -->
          <el-form-item label="适用日期" prop="Days">
            <div class="day-selector">
              <el-button v-for="d in 7" :key="d" :type="isDaySelected(d) ? 'primary' : 'default'" size="mini"
                class="day-button" @click="toggleDay(d)">周{{ ['一', '二', '三', '四', '五', '六', '日'][d - 1] }}</el-button>
            </div>
          </el-form-item>

          <el-row :gutter="12">
            <el-col :span="24">
              <el-form-item label="时间">
                <el-time-picker is-range v-model="mainRange" start-placeholder="开始时间" end-placeholder="结束时间"
                  format="HH:mm" value-format="HH:mm" @change="onMainRangeChange"></el-time-picker>
              </el-form-item>
            </el-col>
          </el-row>

          <!-- 备用适用日期（仅在有备用日期时显示） -->
          <el-divider class="section-divider"></el-divider>
          <el-form-item v-if="periodForm && Array.isArray(periodForm.AltDays) && periodForm.AltDays.length > 0"
            label="适用日期" prop="AltDays">
            <div class="day-selector">
              <el-button v-for="d in 7" :key="'alt' + d" :type="isAltDaySelected(d) ? 'primary' : 'default'" size="mini"
                class="day-button" @click="toggleAltDay(d)">周{{ ['一', '二', '三', '四', '五', '六', '日'][d - 1]
                }}</el-button>
            </div>
          </el-form-item>

          <el-row v-if="periodForm && Array.isArray(periodForm.AltDays) && periodForm.AltDays.length > 0" :gutter="12">
            <el-col :span="24">
              <el-form-item label="时间">
                <el-time-picker is-range v-model="altRange" start-placeholder="开始时间" end-placeholder="结束时间"
                  format="HH:mm" value-format="HH:mm" @change="onAltRangeChange"></el-time-picker>
              </el-form-item>
            </el-col>
          </el-row>

          <!-- <el-form-item label="是否上课" prop="IsClass">
            <el-switch v-model="periodForm.IsClass" active-value="1" inactive-value="0"></el-switch>
          </el-form-item> -->

          <!-- <el-form-item label="时间段分类" prop="TimeSlot">
            <el-select v-model="periodForm.TimeSlot" placeholder="请选择时间段">
              <el-option label="上午" value="上午"></el-option>
              <el-option label="中午" value="中午"></el-option>
              <el-option label="下午" value="下午"></el-option>
              <el-option label="晚上" value="晚上"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="备注" prop="Remarks">
            <el-input v-model="periodForm.Remarks"></el-input>
          </el-form-item> -->
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click.native="periodEditDialogVisible = false">取消</el-button>
          <el-button type="primary" @click.native="submitPeriod" :loading="periodLoading">保存</el-button>
        </div>
      </el-dialog>

    </section>
  </section>
</template>

<script>
import util from "../../../util/date";
import { testapi } from '../../api/modules/auth';
import { getSchedules, createSchedule, updateSchedule, deleteSchedule, getScheduleById, addPeriod, updatePeriod, deletePeriod } from '../../api/modules/schedule-course';
import { BaseApiUrl } from '../../api/base';
import { getSubGrades } from '../../api/modules/department';
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";
import DepartmentPane from '../../components/DepartmentPane'

export default {
  components: { Toolbar, DepartmentPane },
  data() {
    return {
      filters: {
      },
      BaseApiUrl: BaseApiUrl, //网络前缀
      searchList: [
        {
          label: '名称',
          key: 'name',
        },
      ],
      users: [],
      roles: [],
      total: 0,
      buttonList: [],
      currentRow: null,
      page: 1,
      listLoading: false,
      sels: [], //列表选中列
      liveTypeList: [],
      liveTypeId: "",
      addDialogFormVisible: false,
      editFormVisible: false, //编辑界面是否显示
      editLoading: false,
      editFormRules: {
        Name: [{ required: true, message: "请输入名称", trigger: "blur" }],
      },
      gradeList: [], // 新增年级列表
      //编辑界面数据
      editForm: {
        Id: 0,
        Name: "",
        Priority: 0,
        IsDefault: 0,
        Remarks: '',
        GradeIds: [], // 年级可多选
        DepartmentId: 0
      },
      addFormVisible: false, //新增界面是否显示
      addLoading: false,
      addFormRules: {
        Name: [{ required: true, message: "请输入名称", trigger: "blur" }],
      },
      //新增界面数据
      addForm: {
        Name: "",
        Priority: 0,
        IsDefault: 0,
        Remarks: '',
        GradeIds: [], // 年级可多选
        DepartmentId: 0
      },
      // 节次管理
      periodDialogVisible: false,
      periodList: [],
      currentScheduleId: null,
      currentScheduleName: '',
      periodEditDialogVisible: false,
      periodForm: {
        Id: 0,
        ScheduleId: 0,
        ClassNo: 0,
        PeriodName: '',
        StartTime: '',
        EndTime: '',
        AltStartTime: '',
        AltEndTime: '',
        AltDaysMask: 0,
        AltDays: [],
        Days: [1, 2, 3, 4, 5, 6, 7],
        IsClass: 1,
        TimeSlot: '',
        Remarks: ''
      },
      periodLoading: false,
      // 节次编辑表单规则（将在 mounted 时初始化，以便引用 methods）
      periodFormRules: {},
      // 临时范围数组，用于绑定 is-range 控件，保证已选时间能显示
      mainRange: ['', ''],
      altRange: ['', ''],
      DepartmentId: 0,
      currentUserId: '',
      imageUrl: '',
      imageLoadding: false,
      // 适用年级查看弹窗状态。最后更新：2026-09-08
      viewGradeDialog: {
        visible: false,
        title: '查看适用年级',
        name: '',
        departmentName: '',
        isDefault: 0,
        grades: [],
        filterKey: '',
      },
      // leaveType related removed
    };
  },

  computed: {
    // 弹窗中过滤后的年级列表。最后更新：2026-09-08
    filteredViewGrades() {
      const list = this.viewGradeDialog.grades || [];
      const key = (this.viewGradeDialog.filterKey || '').trim().toLowerCase();
      if (!key) {
        return list.map((name) => ({ name }));
      }
      return list
        .filter((name) => String(name).toLowerCase().includes(key))
        .map((name) => ({ name }));
    },
  },

  methods: {
    // 解析年级名称为数组。最后更新：2026-09-08
    parseGradeNames(val) {
      if (!val) return [];
      if (Array.isArray(val)) return val;
      return String(val)
        .split(/[,，、]+/)
        .map(s => s.trim())
        .filter(s => s.length > 0);
    },

    /** 判断两个年级范围是否相同：按逗号拆成 ID 集合比较，忽略顺序，与后端 IsSameGradeScope 一致。创建于 2026-10-08 */
    isSameGradeScope(gradeIdsA, gradeIdsB) {
      const toSet = val => new Set((Array.isArray(val) ? val : String(val || '').split(','))
        .map(x => String(x).trim())
        .filter(x => x !== ''));
      const setA = toSet(gradeIdsA);
      const setB = toSet(gradeIdsB);
      return setA.size === setB.size && [...setA].every(x => setB.has(x));
    },

    /**
     * 编辑时取消默认：同范围内若无其它默认则禁止。创建于 2026-09-20
     */
    onEditDefaultChange(val) {
      if (Number(val) === 1) return;
      const form = this.editForm || {};
      const schoolId = form.DepartmentId || this.DepartmentId;
      const peers = (this.users || []).filter(row => {
        if (!row || String(row.Id) === String(form.Id)) return false;
        if (String(row.DepartmentId) !== String(schoolId)) return false;
        return this.isSameGradeScope(row.GradeIds, form.GradeIds);
      });
      const hasOtherDefault = peers.some(row => Number(row.IsDefault) === 1);
      if (!hasOtherDefault) {
        this.$nextTick(() => {
          this.$set(this.editForm, 'IsDefault', 1);
        });
        this.$message.warning('同一学校/年级范围内必须保留一个默认方案，请先将其他方案设为默认后再取消');
      }
    },

    // 打开适用年级查看弹窗。最后更新：2026-09-08
    openGradeViewDialog(row) {
      if (!row) return;
      const gradeList = this.parseGradeNames(row.GradeName);
      this.viewGradeDialog = {
        visible: true,
        title: `查看适用年级 - ${row.Name || '作息方案'}`,
        name: row.Name || '',
        departmentName: row.DepartmentName || '',
        isDefault: Number(row.IsDefault) === 1 ? 1 : 0,
        grades: gradeList,
        filterKey: '',
      };
    },

    // 复制所有筛选出的年级
    copyAllGradeNames() {
      const grades = (this.filteredViewGrades || []).map((item) => item.name).filter(Boolean);
      if (!grades.length) {
        this.$message.warning('暂无可复制的年级');
        return;
      }
      this.copyTextToClipboard(grades.join('、'));
      this.$message.success(`已复制 ${grades.length} 个年级名称`);
    },

    // 复制单个年级
    copySingleGradeName(text) {
      if (!text) return;
      this.copyTextToClipboard(text);
      this.$message.success(`已复制: ${text}`);
    },

    // 通用剪贴板复制工具
    copyTextToClipboard(text) {
      if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard.writeText(text).catch(() => {
          this.fallbackCopyText(text);
        });
      } else {
        this.fallbackCopyText(text);
      }
    },

    fallbackCopyText(text) {
      const textArea = document.createElement('textarea');
      textArea.value = text;
      textArea.style.position = 'fixed';
      textArea.style.left = '-999999px';
      textArea.style.top = '-999999px';
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();
      try {
        document.execCommand('copy');
      } catch (err) {
        console.error('复制失败', err);
      }
      document.body.removeChild(textArea);
    },

    // 新增方法：根据部门ID获取年级列表
    getGradeListByDepartmentId(departmentId) {
      this.gradeList = [];
      let gradePara = {
        pid: departmentId
      };
      getSubGrades(gradePara).then((res) => {
        if (res.data && res.data.response) {
          this.gradeList = res.data.response;
        }
      });
    },

    treeNodeClick(data, node, component) {
      this.DepartmentId = data.value
      this.handleQuery();
      let para = {
        id: this.DepartmentId,
      };
    },

    dialogCheck(selection, row) {
      this.currentRow = null;
      this.$refs.table.clearSelection();
      if (selection.length === 0) {
        return;
      }
      if (row) {
        this.selectCurrentRow(row);
      }
    },
    selectCurrentRow(val) {
      if (val) {
        this.currentRow = val;
        this.$refs.table.clearSelection();
        this.$refs.table.toggleRowSelection(val, true);
      }
    },
    callFunction(item) {
      if (typeof item.search == 'object') {
        this.filters = item.search
      } else {
        this.filters = {
          key: item.search,
        }
      }
      this[item.Func].apply(this, item)
    },

    handleCurrentChange(val) {
      this.page = val;
      this.handleQuery();
    },

    openEditRow(row) {
      this.currentRow = row;
      this.handleEdit();
    },

    confirmDelete(row) {
      this.currentRow = row;
      this.handleDel();
    },

    // 打开节次管理
    openPeriods(row) {
      if (!row || !row.Id) return;
      this.currentScheduleId = row.Id;
      this.currentScheduleName = row.Name || '';
      this.periodDialogVisible = true;
      this.loadPeriods(row.Id);
    },

    // 加载节次（通过 GetScheduleById 返回的 Periods 字段）
    loadPeriods(scheduleId) {
      this.periodLoading = true;
      getScheduleById({ id: scheduleId }).then((res) => {
        this.periodLoading = false;
        if (res.data && res.data.response) {
          this.periodList = res.data.response.Periods || [];
          // 将每项的 AltDaysMask 转为数组（1-7），并且优先使用 EffectiveTimes 来设置 Days/AltDays
          this.periodList.forEach(p => {
            p.EffectiveTimes = p.EffectiveTimes || [];
            // 优先从 EffectiveTimes 中找主用和备用日期
            const mainDays = p.EffectiveTimes.filter(e => e && !e.IsUsingAlt).map(e => Number(e.DayOfWeekNumber));
            const altDaysFromEff = p.EffectiveTimes.filter(e => e && e.IsUsingAlt).map(e => Number(e.DayOfWeekNumber));
            p.AltDays = (altDaysFromEff && altDaysFromEff.length > 0) ? altDaysFromEff : this.maskToDaysArray(p.AltDaysMask || 0);
            if (mainDays && mainDays.length > 0) {
              p.Days = mainDays;
            } else if (!p.Days || !Array.isArray(p.Days) || p.Days.length === 0) {
              p.Days = [1, 2, 3, 4, 5, 6, 7];
            }
            // 如果备用日期包含周一到周日全部（7天），将其视为主用，清除备用设置
            if (Array.isArray(p.AltDays) && p.AltDays.length === 7) {
              p.Days = [1, 2, 3, 4, 5, 6, 7];
              p.AltDays = [];
              p.AltDaysMask = 0;
              // 如果 EffectiveTimes 中都有 IsUsingAlt 为 true 的条目，则把它们转为主用
              if (Array.isArray(p.EffectiveTimes) && p.EffectiveTimes.filter(e => e && e.IsUsingAlt).length === 7) {
                p.EffectiveTimes = p.EffectiveTimes.map(e => e ? Object.assign({}, e, { IsUsingAlt: false }) : e);
              }
            }
          });
        } else {
          this.periodList = [];
        }
      }).catch(() => {
        this.periodLoading = false;
        this.periodList = [];
      });
    },

    // 将掩码转换为星期序号数组（1-7）
    maskToDaysArray(mask) {
      const arr = [];
      for (let i = 0; i < 7; i++) {
        if (mask & (1 << i)) arr.push(i + 1);
      }
      return arr;
    },

    // 将星期序号数组（1-7）转换为掩码（用于后端 AltDaysMask）
    daysArrayToMask(arr) {
      if (!arr || !Array.isArray(arr) || arr.length === 0) return 0;
      return arr.reduce((s, v) => s + (1 << (Number(v) - 1)), 0);
    },

    // 将掩码转为可读星期名
    formatDays(mask) {
      if (!mask) return '';
      const names = ['周一', '周二', '周三', '周四', '周五', '周六', '周日'];
      const arr = [];
      for (let i = 0; i < 7; i++) {
        if (mask & (1 << i)) arr.push(names[i]);
      }
      return arr.join(',');
    },

    // 根据行数据显示适用日期：优先使用 AltDays 数组（如果存在），否则使用 AltDaysMask，再否则使用主用 Days
    displayDays(row) {
      const names = ['周一', '周二', '周三', '周四', '周五', '周六', '周日'];
      // 优先使用已加载的 AltDays 数组（loadPeriods 已将掩码转换为 AltDays）
      if (row && Array.isArray(row.AltDays) && row.AltDays.length > 0) {
        const arr = row.AltDays.slice().sort((a, b) => a - b);
        if (arr.length === 7) return '周一-周日';
        return arr.map(d => names[(d - 1) % 7]).join(',');
      }
      // 其次退回到 AltDaysMask（兼容未转换的情况）
      if (row && row.AltDaysMask && row.AltDaysMask > 0) {
        return this.formatDays(row.AltDaysMask);
      }
      // 否则使用主用 Days
      const days = (row && Array.isArray(row.Days) && row.Days.length > 0) ? row.Days.slice() : [1, 2, 3, 4, 5, 6, 7];
      const all = [1, 2, 3, 4, 5, 6, 7].every(d => days.indexOf(d) !== -1);
      if (all) return '周一-周日';
      days.sort((a, b) => a - b);
      return days.map(d => names[(d - 1) % 7]).join(',');
    },

    // 从 EffectiveTimes 列表中提取某类（正常/备用）对应的日期字符串
    effectiveDays(row, isAlt) {
      if (row && Array.isArray(row.EffectiveTimes) && row.EffectiveTimes.length > 0) {
        const list = row.EffectiveTimes
          .filter(e => !!e && Boolean(e.IsUsingAlt) === Boolean(isAlt) && (e.StartTime || e.EndTime || e.TimeRange))
          .sort((a, b) => (a.DayOfWeekNumber || 0) - (b.DayOfWeekNumber || 0));
        if (list.length === 0) return '';
        return list.map(e => e.DayName).join(',');
      }
      // 兼容：若没有 EffectiveTimes，则退回到 AltDays/Days
      if (isAlt) {
        if (row && Array.isArray(row.AltDays) && row.AltDays.length > 0) {
          const names = ['周一', '周二', '周三', '周四', '周五', '周六', '周日'];
          return row.AltDays.slice().sort((a, b) => a - b).map(d => names[(d - 1) % 7]).join(',');
        }
        if (row && row.AltDaysMask && row.AltDaysMask > 0) return this.formatDays(row.AltDaysMask);
        return '';
      } else {
        const days = (row && Array.isArray(row.Days) && row.Days.length > 0) ? row.Days.slice() : [];
        if (days.length === 0) return '';
        const names = ['周一', '周二', '周三', '周四', '周五', '周六', '周日'];
        return days.sort((a, b) => a - b).map(d => names[(d - 1) % 7]).join(',');
      }
    },

    // 从 EffectiveTimes 列表中合并时间范围（若同一类有多个不同时间，则用分号分隔）
    effectiveTimesSummary(row, isAlt) {
      if (row && Array.isArray(row.EffectiveTimes) && row.EffectiveTimes.length > 0) {
        const list = row.EffectiveTimes.filter(e => !!e && Boolean(e.IsUsingAlt) === Boolean(isAlt) && e.TimeRange).map(e => e.TimeRange);
        const uniq = Array.from(new Set(list));
        if (uniq.length === 0) return '';
        return uniq.join('；');
      }
      // 兼容：若没有 EffectiveTimes，则退回到 StartTime/EndTime
      if (isAlt) {
        if (row && row.AltStartTime) return `${row.AltStartTime || ''}-${row.AltEndTime || ''}`;
        return '';
      } else {
        if (row && row.StartTime) return `${row.StartTime || ''}-${row.EndTime || ''}`;
        return '';
      }
    },

    // 按时间段分组并生成“周一,周三 07:04-08:06”形式的行数组
    groupedEffectiveLines(row, isAlt) {
      if (row && Array.isArray(row.EffectiveTimes) && row.EffectiveTimes.length > 0) {
        const list = row.EffectiveTimes.filter(e => !!e && Boolean(e.IsUsingAlt) === Boolean(isAlt) && e.TimeRange);
        if (list.length === 0) return [];
        // 按 TimeRange 分组
        const map = new Map();
        list.forEach(e => {
          const key = e.TimeRange || `${e.StartTime || ''}-${e.EndTime || ''}`;
          if (!map.has(key)) map.set(key, []);
          map.get(key).push(e.DayName);
        });
        const lines = [];
        for (const [time, days] of map.entries()) {
          lines.push(`${days.join(',')} ${time}`);
        }
        return lines;
      }
      // 兼容回退：没有 EffectiveTimes 时用已有字段构造单行
      const days = this.effectiveDays(row, isAlt);
      const time = this.effectiveTimesSummary(row, isAlt);
      if (!days && !time) return [];
      return [`${days ? days : ''}${days && time ? ' ' : ''}${time ? time : ''}`.trim()];
    },

    // 根据星期号查找 EffectiveTimes 条目（如果有）
    findEffectiveForDay(day) {
      if (!this.periodForm || !Array.isArray(this.periodForm.EffectiveTimes)) return null;
      return this.periodForm.EffectiveTimes.find(e => e && Number(e.DayOfWeekNumber) === Number(day)) || null;
    },

    // 解析 TimeRange 字符串 "HH:mm-HH:mm"
    parseTimeRange(range) {
      if (!range || typeof range !== 'string') return ['', ''];
      const parts = range.split('-').map(s => s.trim());
      return [parts[0] || '', parts[1] || ''];
    },

    // 解析一行文本（如 "周一,周二 11:00-11:45"）为 days 数组和 time 字符串
    parseEffectiveLine(line) {
      if (!line || typeof line !== 'string') return { days: [], time: '' };
      const idx = line.lastIndexOf(' ');
      if (idx === -1) {
        if (/\d{1,2}:\d{2}/.test(line)) return { days: [], time: line.trim() };
        return { days: line.split(',').map(s => s.trim()).filter(Boolean), time: '' };
      }
      const daysPart = line.slice(0, idx).trim();
      const timePart = line.slice(idx + 1).trim();
      const days = daysPart ? daysPart.split(',').map(s => s.trim()).filter(Boolean) : [];
      return { days, time: timePart };
    },

    // 为指定日期（day）自动赋值范围，isAlt 表示是否为备用
    assignRangeForDay(day, isAlt) {
      const e = this.findEffectiveForDay(day);
      if (!e) return;
      // 仅在 EffectiveTimes 的 IsUsingAlt 与请求匹配时自动赋值
      if (Boolean(e.IsUsingAlt) !== Boolean(isAlt)) return;
      const [s, t] = e.TimeRange ? this.parseTimeRange(e.TimeRange) : [e.StartTime || '', e.EndTime || ''];
      if (isAlt) {
        this.altRange = [s || '', t || ''];
        this.periodForm.AltStartTime = s || '';
        this.periodForm.AltEndTime = t || '';
      } else {
        this.mainRange = [s || '', t || ''];
        this.periodForm.StartTime = s || '';
        this.periodForm.EndTime = t || '';
      }
    },

    // 切换主用日期按钮（1-7），互斥处理：选中时从 AltDays 中移除对应项
    toggleDay(d) {
      if (!Array.isArray(this.periodForm.Days)) this.periodForm.Days = [];
      if (!Array.isArray(this.periodForm.AltDays)) this.periodForm.AltDays = [];
      const idx = this.periodForm.Days.indexOf(d);
      if (idx === -1) {
        // 选中：加入 Days，并从 AltDays 中移除
        this.periodForm.Days.push(d);
        const aidx = this.periodForm.AltDays.indexOf(d);
        if (aidx !== -1) this.periodForm.AltDays.splice(aidx, 1);
        // 如果有 EffectiveTimes，尝试为该日期自动填充主时间
        this.assignRangeForDay(d, false);
      } else {
        // 取消选中：移除 Days 并确保加入 AltDays（每天都要有设置）
        this.periodForm.Days.splice(idx, 1);
        if (this.periodForm.AltDays.indexOf(d) === -1) this.periodForm.AltDays.push(d);
        // 将该日期移动到备用，尝试自动填充备用时间
        this.assignRangeForDay(d, true);
      }
    },

    // 切换备用日期按钮（1-7），互斥处理：选中时从 Days 中移除对应项
    toggleAltDay(d) {
      if (!Array.isArray(this.periodForm.AltDays)) this.periodForm.AltDays = [];
      if (!Array.isArray(this.periodForm.Days)) this.periodForm.Days = [];
      const idx = this.periodForm.AltDays.indexOf(d);
      if (idx === -1) {
        // 选中：加入 AltDays 并从 Days 中移除
        this.periodForm.AltDays.push(d);
        const didx = this.periodForm.Days.indexOf(d);
        if (didx !== -1) this.periodForm.Days.splice(didx, 1);
        // 选中备用：若 EffectiveTimes 指定了备用时间，自动填充备用时间范围
        this.assignRangeForDay(d, true);
      } else {
        // 取消选中：移除 AltDays 并确保加入 Days
        this.periodForm.AltDays.splice(idx, 1);
        if (this.periodForm.Days.indexOf(d) === -1) this.periodForm.Days.push(d);
        // 取消备用：将该日设回主用，尝试自动填充主时间范围
        this.assignRangeForDay(d, false);
      }
    },

    // （保留空位，互斥逻辑由 toggleDay / toggleAltDay 处理）

    updateArraySelection(arr, value, selected) {
      if (!Array.isArray(arr)) return; // defensive
      const idx = arr.indexOf(value);
      if (selected && idx === -1) arr.push(value);
      if (!selected && idx !== -1) arr.splice(idx, 1);
    },

    isDaySelected(d) {
      return this.periodForm && Array.isArray(this.periodForm.Days) && this.periodForm.Days.includes(d);
    },

    isAltDaySelected(d) {
      return this.periodForm && Array.isArray(this.periodForm.AltDays) && this.periodForm.AltDays.includes(d);
    },

    // 主时间范围变化，同步到 StartTime / EndTime
    onMainRangeChange(val) {
      if (!val) return;
      if (Array.isArray(val)) {
        this.periodForm.StartTime = val[0] || '';
        this.periodForm.EndTime = val[1] || '';
      }
    },

    // 备用时间范围变化，同步到 AltStartTime / AltEndTime
    onAltRangeChange(val) {
      if (!val) return;
      if (Array.isArray(val)) {
        this.periodForm.AltStartTime = val[0] || '';
        this.periodForm.AltEndTime = val[1] || '';
      }
    },

    // 验证主时间范围（StartTime/EndTime）
    validateMainTime(rule, value, callback) {
      if (!this.periodForm.StartTime || !this.periodForm.EndTime) {
        callback(new Error('请选择开始和结束时间'));
      } else {
        callback();
      }
    },

    // 验证备用时间（仅当有 AltDays 时需要）
    validateAltTime(rule, value, callback) {
      if (this.periodForm && Array.isArray(this.periodForm.AltDays) && this.periodForm.AltDays.length > 0) {
        if (!this.periodForm.AltStartTime || !this.periodForm.AltEndTime) {
          callback(new Error('请选择备用开始和结束时间'));
          return;
        }
      }
      callback();
    },

    // 打开新增节次对话框
    addPeriodDialog() {
      this.periodForm = Object.assign({}, {
        Id: 0,
        ScheduleId: this.currentScheduleId,
        ClassNo: (this.periodList.length ? (Math.max(...this.periodList.map(p => Number(p.ClassNo || 0))) + 1) : 1),
        PeriodName: '',
        StartTime: '',
        EndTime: '',
        AltStartTime: '',
        AltEndTime: '',
        AltDaysMask: 0,
        AltDays: [],
        Days: [1, 2, 3, 4, 5, 6, 7],
        IsClass: 1,
        TimeSlot: '',
        Remarks: ''
      });
      // 确保 EffectiveTimes 存在且备用/主用数组初始化
      this.periodForm.EffectiveTimes = [];
      this.periodForm.AltDays = [];
      this.periodForm.AltDaysMask = 0;
      // 初始化范围数组，保证范围控件显示
      this.mainRange = [this.periodForm.StartTime || '', this.periodForm.EndTime || ''];
      this.altRange = [this.periodForm.AltStartTime || '', this.periodForm.AltEndTime || ''];
      this.periodEditDialogVisible = true;
      this.$nextTick(() => {
        if (this.$refs.periodFormRef) this.$refs.periodFormRef.clearValidate();
      });
    },

    // 编辑节次
    editPeriodDialog(row) {
      this.periodForm = Object.assign({}, row);
      // 确保 EffectiveTimes 存在
      this.periodForm.EffectiveTimes = this.periodForm.EffectiveTimes || [];
      // 优先从 EffectiveTimes 中设置主用/备用日期
      const mainDays = this.periodForm.EffectiveTimes.filter(e => e && !e.IsUsingAlt).map(e => Number(e.DayOfWeekNumber));
      const altDaysFromEff = this.periodForm.EffectiveTimes.filter(e => e && e.IsUsingAlt).map(e => Number(e.DayOfWeekNumber));
      this.periodForm.AltDays = (altDaysFromEff && altDaysFromEff.length > 0) ? altDaysFromEff : this.maskToDaysArray(this.periodForm.AltDaysMask || 0);
      if (mainDays && mainDays.length > 0) {
        this.periodForm.Days = mainDays;
      } else if (!this.periodForm.Days || !Array.isArray(this.periodForm.Days) || this.periodForm.Days.length === 0) {
        this.periodForm.Days = [1, 2, 3, 4, 5, 6, 7];
      }
      // 如果备用日期包含周一到周日全部（7天），将其视为主用并清除备用设置（UI 不再显示备用）
      if (Array.isArray(this.periodForm.AltDays) && this.periodForm.AltDays.length === 7) {
        this.periodForm.Days = [1, 2, 3, 4, 5, 6, 7];
        this.periodForm.AltDays = [];
        this.periodForm.AltDaysMask = 0;
        this.periodForm.AltStartTime = '';
        this.periodForm.AltEndTime = '';
        // 将 EffectiveTimes 中的备用条目也切换为主用（避免列表显示备用行）
        if (Array.isArray(this.periodForm.EffectiveTimes) && this.periodForm.EffectiveTimes.filter(e => e && e.IsUsingAlt).length === 7) {
          this.periodForm.EffectiveTimes = this.periodForm.EffectiveTimes.map(e => e ? Object.assign({}, e, { IsUsingAlt: false }) : e);
        }
      }
      // 初始化范围数组，确保范围控件可以显示已保存的时间
      this.mainRange = [this.periodForm.StartTime || '', this.periodForm.EndTime || ''];
      this.altRange = [this.periodForm.AltStartTime || '', this.periodForm.AltEndTime || ''];
      this.periodEditDialogVisible = true;
      this.$nextTick(() => {
        if (this.$refs.periodFormRef) this.$refs.periodFormRef.clearValidate();
      });
    },

    // 提交节次（新增/更新）
    submitPeriod() {
      // 在提交前验证表单
      this.$refs.periodFormRef.validate((valid) => {
        if (!valid) return;

        const para = Object.assign({}, this.periodForm);
        para.ScheduleId = this.currentScheduleId;
        // 将选择的星期数组转换为掩码
        para.AltDaysMask = this.daysArrayToMask(para.AltDays);
        // 后端不需要数组字段
        delete para.AltDays;
        // 简单校验：ClassNo
        if (para.ClassNo === undefined || para.ClassNo === null || para.ClassNo === '') {
          this.$message.error('请填写节次数序');
          return;
        }
        this.periodLoading = true;
        const call = para.Id && para.Id > 0 ? updatePeriod : addPeriod;
        call(para).then((res) => {
          this.periodLoading = false;
          if (res.data && res.data.success) {
            this.$message.success(res.data.msg || '保存成功');
            this.periodEditDialogVisible = false;
            this.loadPeriods(this.currentScheduleId);
          } else {
            this.$message.error(res.data.msg || '保存失败');
          }
        }).catch(() => {
          this.periodLoading = false;
        });
      });
    },

    // 删除节次
    removePeriod(row) {
      this.$confirm('确认删除该节次吗？', '提示', { type: 'warning' }).then(() => {
        deletePeriod({ id: row.Id }).then((res) => {
          if (res.data && res.data.success) {
            this.$message.success(res.data.msg || '删除成功');
            this.loadPeriods(this.currentScheduleId);
          } else {
            this.$message.error(res.data.msg || '删除失败');
          }
        });
      }).catch(() => { });
    },

    //获取用户列表
    handleQuery() {
      let para = {
        page: this.page,
        departmentId: this.DepartmentId,
        ...this.filters,
      }
      this.listLoading = true;

      testapi();
      //NProgress.start();
      getSchedules(para).then((res) => {
        this.total = res.data.response.dataCount;
        this.users = res.data.response.data;
        this.listLoading = false;
        //NProgress.done();
      });
    },
    //删除
    handleDel() {
      let row = this.currentRow;
      if (!row) {
        this.$message({
          message: "请选择要删除的一行数据！",
          type: "error",
        });

        return;
      }
      this.$confirm("确认删除该记录吗?", "提示", {
        type: "warning",
      })
        .then(() => {
          this.listLoading = true;
          //NProgress.start();
          let para = { id: row.Id };
          deleteSchedule(para).then((res) => {
            if (util.isEmt.format(res)) {
              this.listLoading = false;
              return;
            }
            this.listLoading = false;
            //NProgress.done();
            if (res.data.success) {
              this.$message({
                message: "删除成功",
                type: "success",
              });
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }

            this.handleQuery();
          });
        })
        .catch(() => { });
    },
    //显示编辑界面
    handleEdit() {
      let row = this.currentRow;
      if (!row) {
        this.$message({
          message: "请选择要编辑的一行数据！",
          type: "error",
        });

        return;
      }
      this.editFormVisible = true;

      // 将后端的 GradeIds 字符串转换为数组用于多选
      const converted = Object.assign({}, row);
      if (converted.GradeIds && typeof converted.GradeIds === 'string') {
        converted.GradeIds = converted.GradeIds.split(',').filter(x => x !== '');
      } else {
        converted.GradeIds = [];
      }
      converted.IsDefault = Number(converted.IsDefault) === 1 ? 1 : 0;
      this.editForm = converted;
      // 优先使用当前方案绑定的所属学校 ID，若无则使用当前页面统一选中的 ID 兜底
      this.editForm.DepartmentId = row.DepartmentId || this.DepartmentId;

      // 获取年级列表
      this.getGradeListByDepartmentId(this.editForm.DepartmentId);
    },
    //显示新增界面
    handleAdd() {
      // 限制：必须先在左侧选择具体的学校机构才能进行新增
      if (!this.DepartmentId || this.DepartmentId === '0' || this.DepartmentId === 0) {
        this.$message.warning("请先在左侧选择具体的学校机构！");
        return;
      }
      this.addFormVisible = true;
      this.addForm = {
        Name: "",
        Priority: 0,
        IsDefault: 1,
        Remarks: '',
        GradeIds: [], // 新增年级字段（多选）
        DepartmentId: this.DepartmentId, // 直接使用当前页面统一选中的学校 ID
      };
      // 获取年级列表（使用当前选择的部门）
      this.getGradeListByDepartmentId(this.DepartmentId);
    },
    //编辑
    editSubmit: function () {
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(() => {
            this.editLoading = true;
            //NProgress.start();
            let para = Object.assign({}, this.editForm);
            para.IsDefault = Number(para.IsDefault) === 1 ? 1 : 0;

            // 将 GradeIds 数组转换为逗号分隔字符串
            para.GradeIds = Array.isArray(para.GradeIds) ? para.GradeIds.join(',') : (para.GradeIds || '');

            updateSchedule(para).then((res) => {
              if (util.isEmt.format(res)) {
                this.editLoading = false;
                return;
              }
              if (res.data.success) {
                this.editLoading = false;
                this.$message({
                  message: res.data.msg,
                  type: "success",
                });
                this.$refs["editForm"].resetFields();
                this.editFormVisible = false;
                this.handleQuery();
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "error",
                });
                this.editLoading = false;
              }
            });
          });
        }
      });
    },
    //新增
    addSubmit: function () {
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(() => {
            this.addLoading = true;
            //NProgress.start();
            let para = Object.assign({}, this.addForm);
            para.IsDefault = Number(para.IsDefault) === 1 ? 1 : 0;

            // 将 GradeIds 数组转换为逗号分隔字符串
            para.GradeIds = Array.isArray(para.GradeIds) ? para.GradeIds.join(',') : (para.GradeIds || '');

            createSchedule(para).then((res) => {
              if (util.isEmt.format(res)) {
                this.addLoading = false;
                return;
              }

              if (res.data.success) {
                this.addLoading = false;
                //NProgress.done();
                this.$message({
                  message: res.data.msg,
                  type: "success",
                });
                this.$refs["addForm"].resetFields();
                this.addFormVisible = false;
                this.handleQuery();
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "error",
                });
                this.addLoading = false;
              }
            });
          });
        }
      });
    },
  },

  watch: {
    mainRange(val) {
      if (Array.isArray(val) && this.periodForm) {
        this.periodForm.StartTime = val[0] || '';
        this.periodForm.EndTime = val[1] || '';
      }
    },
    altRange(val) {
      if (Array.isArray(val) && this.periodForm) {
        this.periodForm.AltStartTime = val[0] || '';
        this.periodForm.AltEndTime = val[1] || '';
      }
    }
    ,
    // 当编辑表单的 AltDays 被设置为全周（7 天）时，自动清除备用设置并把 EffectiveTimes 标记为主用
    periodForm: {
      deep: true,
      handler(newVal) {
        if (!newVal) return;
        try {
          if (Array.isArray(newVal.AltDays) && newVal.AltDays.length === 7) {
            this.periodForm.Days = [1, 2, 3, 4, 5, 6, 7];
            this.periodForm.AltDays = [];
            this.periodForm.AltDaysMask = 0;
            this.periodForm.AltStartTime = '';
            this.periodForm.AltEndTime = '';
            if (Array.isArray(this.periodForm.EffectiveTimes) && this.periodForm.EffectiveTimes.filter(e => e && e.IsUsingAlt).length === 7) {
              this.periodForm.EffectiveTimes = this.periodForm.EffectiveTimes.map(e => e ? Object.assign({}, e, { IsUsingAlt: false }) : e);
            }
          }
        } catch (e) {
          // defensive: ignore watcher errors
        }
      }
    }
  },
  mounted() {

    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    this.buttonList = getButtonList(this.$route.path, routers);
    // 初始化节次表单规则，放在 mounted 中以便引用到 methods
    this.periodFormRules = {
      PeriodName: [{ required: true, message: '请输入节次名称', trigger: 'blur' }],
      StartTime: [{ validator: this.validateMainTime, trigger: 'change' }],
      AltStartTime: [{ validator: this.validateAltTime, trigger: 'change' }]
    };
  },
};
</script>

<style scoped>
.custom-tbl /deep/ .has-gutter .el-checkbox {
  display: none;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: var(--btn-primary, #2563eb);
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 106.8px;
  height: 106.8px;
  line-height: 106.8px;
  text-align: center;
}

.avatar {
  width: 106.8px;
  height: 106.8px;
  display: block;
}

.avatar-uploader-tip {
  position: absolute;
  width: 100%;
  height: 1vw;
  bottom: 20px;
  color: gray;
  z-index: 99;
}

.dialog-footer {
  text-align: center;
}

.day-selector {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.day-button {
  min-width: 56px;
  border-radius: 6px;
  border: 1px solid #d9d9d9;
}

.section-divider {
  margin: 12px 0;
}

/* 样式：合并的 日期 / 时间 列美化 */
.combo-line {
  display: flex;
  align-items: flex-start;
}

.combo-label {
  width: 56px;
  color: #909399;
  font-weight: 600;
  font-size: 13px;
  line-height: 20px;
}

.combo-values {
  flex: 1;
  color: #606266;
  font-size: 14px;
  line-height: 20px;
}

/* 使日期/时间列内容水平居中 */
.combo-values {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.combo-values div {
  white-space: normal;
  word-break: keep-all;
}

.combo-values div+div {
  margin-top: 6px;
}

/* 标签行样式：星期 tag 与时间文本 */
.tag-line {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

.time-text {
  color: #606266;
  font-size: 13px;
}

/* 时间单独一行，允许换行 */
.time-line {
  margin-top: 4px;
  color: #606266;
  font-size: 13px;
  word-break: break-all;
}
</style>

<style>
/* 列表适用年级快速查看链接按钮。最后修改：2026-09-08 */
.schedule-grade-link-btn {
  padding: 4px 10px;
  font-size: 13px;
  color: #2563eb;
  background-color: #eff6ff;
  border-radius: 4px;
  line-height: 18px;
  border: 1px solid #bfdbfe;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  cursor: pointer;
  transition: all 0.2s;
}

.schedule-grade-link-btn:hover,
.schedule-grade-link-btn:focus {
  color: #1d4ed8;
  background-color: #dbeafe;
  border-color: #93c5fd;
}

/* 全校通用范围徽章标签。最后更新：2026-09-08 */
.schedule-scope-tag {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  font-weight: 500;
  border-radius: 4px;
  padding: 2px 8px;
}

/* 适用年级查看弹窗样式（全局穿透，支持 append-to-body）。最后修改：2026-09-08 */
.schedule-grade-view-dialog .el-dialog__body {
  padding: 16px 20px 10px;
}

.schedule-view-head {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 16px;
  background-color: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  padding: 10px 16px;
  margin-bottom: 14px;
}

.schedule-view-head-item {
  font-size: 13px;
  color: #334155;
}

.schedule-view-head-item .label {
  color: #64748b;
}

.schedule-view-head-item .val {
  font-weight: 500;
  color: #0f172a;
}

.schedule-view-head-item .count-badge {
  display: inline-block;
  padding: 1px 8px;
  border-radius: 12px;
  font-size: 12px;
  background-color: #eff6ff;
  color: #2563eb;
  font-weight: 600;
}

.schedule-view-toolbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  margin-bottom: 12px;
}

.schedule-view-search-input {
  max-width: 280px;
}

.schedule-view-table-wrap {
  border-radius: 4px;
  overflow: hidden;
}

.schedule-view-table .grade-text {
  font-size: 13px;
  color: #1e293b;
  font-weight: 500;
}

.schedule-view-empty {
  padding: 30px 0;
  color: #94a3b8;
  font-size: 13px;
}
</style>
